export const downloadIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="M8 1v8.727M5.2 6.455 8 9.727l2.8-3.272M15 9.727v1.091C15 12.023 14.164 13 13.133 13H2.867C1.836 13 1 12.023 1 10.818v-1.09"/></svg>`,
    name: 'download'
};